import { useEffect } from 'react';
import { isAdaptiveActive } from '../helpers/ElementHelpers';
import { isMobile } from '../helpers/DeviceHelpers';
import { isNullOrEmpty } from '../helpers/ObjectHelpers';
import moment from 'moment';

export const useAdaptiveValue = (
	show: boolean,
	adaptive: boolean,
	setLocalValue: (value: Date | null) => void,
	localValue: Date | null,
    value: Date | null) => {
	useEffect(() => {

		if (!isMobile()) return;

		if (show && adaptive && isAdaptiveActive()) {
			if (isNullOrEmpty(localValue)) {
				setLocalValue(moment().toDate());
			}
		}
		if (!show && isNullOrEmpty(value)) {
			setLocalValue(null);
		}
	}, [show, adaptive]);
};
